export const STORE_IS_API_LOADING = "STORE_IS_API_LOADING"
export const storeApiLoading = state => ({
  type: STORE_IS_API_LOADING,
  payload: state,
})

export const SET_CLOSE_SNACKBAR = "SET_CLOSE_SNACKBAR"
export const setCloseSnackbar = () => ({
  type: SET_CLOSE_SNACKBAR,
})

export const SET_SUCCESS = "SET_SUCCESS"
export const setSuccess = payload => ({
  type: SET_SUCCESS,
  payload,
})

export const SET_ERROR = "SET_ERROR"
export const setError = payload => ({
  type: SET_ERROR,
  payload,
})

export const STORE_IS_AUTHENTICATION = "STORE_IS_AUTHENTICATION"
export const storeIsAuthentication = payload => ({
  type: STORE_IS_AUTHENTICATION,
  payload,
})

export const STORE_IS_AUTH_LOADING = "STORE_IS_AUTH_LOADING"
export const storeIsAuthLoading = payload => ({
  type: STORE_IS_AUTH_LOADING,
  payload,
})

export const GET_AGREEMENT_SELECTION = "GET_AGREEMENT_SELECTION"
export const getAgreementSelection = () => ({
  type: GET_AGREEMENT_SELECTION,
})

export const PUT_ADVERTISING_AGREEMENT = "PUT_ADVERTISING_AGREEMENT"
export const putAdvertisingAgreement = advertisingAgreement => ({
  type: PUT_ADVERTISING_AGREEMENT,
  payload: advertisingAgreement,
})

export const STORE_ADVERTISING_AGREEMENT = "STORE_ADVERTISING_AGREEMENT"
export const storeAdvertisingAgreement = advertisingAgreement => ({
  type: STORE_ADVERTISING_AGREEMENT,
  payload: advertisingAgreement,
})

export const STORE_ADVERTISING_CARD_IS_DISPLAY =
  "STORE_ADVERTISING_CARD_IS_DISPLAY"
export const storeAdvertisingCardIsDisplay = advertisingCardIsDisplay => ({
  type: STORE_ADVERTISING_CARD_IS_DISPLAY,
  payload: advertisingCardIsDisplay,
})

export const PUT_PERSONAL_RELATION_AGREEMENT = "PUT_PERSONAL_RELATION_AGREEMENT"
export const putPersonalRelationAgreement = personalRelationAgreement => ({
  type: PUT_PERSONAL_RELATION_AGREEMENT,
  payload: personalRelationAgreement,
})

export const STORE_CIRCUS_AGREEMENT = "STORE_CIRCUS_AGREEMENT"
export const storeCircusAgreement = circusAgreement => ({
  type: STORE_CIRCUS_AGREEMENT,
  payload: circusAgreement,
})

export const STORE_PERSONAL_RELATION_AGREEMENT =
  "STORE_PERSONAL_RELATION_AGREEMENT"
export const storePersonalRelationAgreement = personalRelationAgreement => ({
  type: STORE_PERSONAL_RELATION_AGREEMENT,
  payload: personalRelationAgreement,
})

export const STORE_PERSONAL_RELATION_CARD_IS_DISPLAY =
  "STORE_PERSONAL_RELATION_CARD_IS_DISPLAY"
export const storePersonalRelationCardIsDisplay = personalRelationCardIsDisplay => ({
  type: STORE_PERSONAL_RELATION_CARD_IS_DISPLAY,
  payload: personalRelationCardIsDisplay,
})

export const STORE_THIRD_PARTY_AGREEMENT = "STORE_THIRD_PARTY_AGREEMENT"
export const storeThirdPartyAgreement = thirdPartyAgreement => ({
  type: STORE_THIRD_PARTY_AGREEMENT,
  payload: thirdPartyAgreement,
})

export const STORE_THIRD_PARTY_CARD_IS_DISPLAY =
  "STORE_THIRD_PARTY_CARD_IS_DISPLAY"
export const storeThirdPartyCardIsDisplay = thirdPartyCardIsDisplay => ({
  type: STORE_THIRD_PARTY_CARD_IS_DISPLAY,
  payload: thirdPartyCardIsDisplay,
})

export const PUT_THIRD_PARTY_AGREEMENT = "PUT_THIRD_PARTY_AGREEMENT"
export const putThirdPartyAgreement = thirdPartyAgreement => ({
  type: PUT_THIRD_PARTY_AGREEMENT,
  payload: thirdPartyAgreement,
})

export const STORE_AGREEMENT_SELECTION_MODAL_IS_OPEN =
  "STORE_AGREEMENT_SELECTION_MODAL_IS_OPEN"
export const storeAgreementSelectionModalIsOpen = agreementSelectionModalIsOpen => ({
  type: STORE_AGREEMENT_SELECTION_MODAL_IS_OPEN,
  payload: agreementSelectionModalIsOpen,
})

export const STORE_TIMEOUT_MODAL_IS_OPEN = "STORE_TIMEOUT_MODAL_IS_OPEN"
export const storeTimeoutModalIsOpen = props => ({
  type: STORE_TIMEOUT_MODAL_IS_OPEN,
  payload: props,
})
